import React, { useCallback, useRef } from 'react'

import * as R from 'ramda'
import clsx from 'clsx'
import { withFormsy } from 'formsy-react'
import { TextField, withStyles } from '@material-ui/core'
import { findNumbers } from 'libphonenumber-js'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'

const styles = (theme) => ({
  muiPhoneInput: {
    width: '100% !important',
    '& .react-tel-input .form-control': {
      width: '100% !important',
    },
    '& .react-tel-input .special-label': {
      left: '10px !important',
      fontSize: '11px',
      color: '#94969d',
    },
    '& .react-tel-input :disabled': {
      color: 'rgba(0, 0, 0, 0.26) !important',
      backgroundColor: 'rgb(0 0 0 / 8%) !important',
    },
  },
  search: {
    padding: '10px !important',
    '& .search-box': {
      margin: '0 !important',
      width: '100% !important',
      height: '30px !important',
      padding: '0 10px !important',
    },
  },
  countryList: {
    maxHeight: '200px !important',
    zIndex: '100 !important',
    top: '-1rem !important',
  },
  flagButton: {
    '& div': {
      'z-index': '1!important',
    },
  },
})

export const validatePhoneNumber = (values, value) => {
  if (R.isNil(value) || R.isEmpty(value)) return true
  if (
    value &&
    findNumbers(value, 'US', {
      v2: true,
    }).length <= 0
  ) {
    return false
  }
  return true
}

const PhoneNumberInputFormsy = ({
  classes,
  containerClassName,
  value,
  setValue,
  setValueOnBlur,
  defaultCountry,
  inputExtraProps,
  label,
  required,
  isScrollWhenFocus = false,
  onChange,
  variantType = false,
  errorMessage,
  isPristine,
  isValid,
  ...props
}) => {
  const delayTimeBeforeScroll = 500
  const phoneRef = useRef(null)

  const scrollToFocus = () => {
    isScrollWhenFocus &&
      setTimeout(() => {
        if (
          R.compose(
            R.not,
            R.anyPass([R.isNil, R.isEmpty]),
            R.prop('current'),
          )(phoneRef)
        )
          phoneRef.current.scrollIntoView({ behavior: 'smooth' })
      }, delayTimeBeforeScroll)
  }

  const handleChange = (value, data) => {
    const fullPhoneNumber = `+${value}`
    setValue(fullPhoneNumber)
    if (onChange) onChange(fullPhoneNumber, data)
  }

  const handleBlur = setValueOnBlur ? setValueOnBlur : (value) => value

  const isValidCallback = useCallback(() => {
    return isPristine ? true : isValid
  }, [isPristine, isValid])

  return (
    <div
      className={clsx(classes.muiPhoneInput, containerClassName)}
      onClick={scrollToFocus}
      ref={phoneRef}
    >
      <PhoneInput
        {...props}
        isValid={isValidCallback}
        autoFormat={false}
        buttonClass={classes.flagButton}
        dropdownClass={classes.countryList}
        searchClass={classes.search}
        country={defaultCountry}
        value={value}
        enableSearch={true}
        countryCodeEditable={false}
        onChange={handleChange}
        specialLabel={`${label} ${required ? '*' : ''}`}
        inputExtraProps={{
          required,
          autoComplete: 'off',
          variant: variantType || 'outlined',
          error: Boolean(errorMessage),
          helperText: errorMessage,
          ...inputExtraProps,
        }}
        onBlur={handleBlur}
        component={TextField}
        enableTerritories={true}
      />
      {errorMessage && (
        <div id="phone-error-message" className="text-red pt-2 text-xs">
          {errorMessage}
        </div>
      )}
    </div>
  )
}

export default withStyles(styles)(
  React.memo(withFormsy(PhoneNumberInputFormsy)),
)
